import * as types from './action-types'
import firebaseDatabase from './firebaseDatabase'

export function loadContent() {
  return dispatch => {
    dispatch(loadContentStarted());
    return firebaseDatabase.ref('/').once('value', snap => {
      const content = snap.val()
      dispatch(contentLoaded(content))
    })
    .catch((error) => {
      console.log(error)
    })
  }
}

function loadContentStarted () {
  return {
    type: types.LOAD_CONTENT_STARTED
  }
}

function contentLoaded (content) {
  return {
    type: types.CONTENT_LOADED,
    payload: content
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/load-content.js